// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ZdkVl","openItemBtn":"styles_openItemBtn__eJsBt","deleteItemBtn":"styles_deleteItemBtn__hgTWY","header":"styles_header__hPMyc"};